import axios from "axios";

export const SCHOOL_URL = "/School";

// Okul Profil Bilgilerini Elde Eder
export function getSchoolProfile() {
  return axios.get(SCHOOL_URL);
}

// Okul Profil Bilgilerini Kaydeder
export function saveSchoolProfile(schoolProfile) {
  return axios.post(SCHOOL_URL, schoolProfile);
}